(function(){
  if(window.__bmpWarrantyUpsell)return;window.__bmpWarrantyUpsell=true;
  var WARRANTY_HANDLE='extension-de-garantie-premium';
  var SKIP_HANDLES=[WARRANTY_HANDLE];
  var VARIANTS={premium:60869072388426,premiumPlus:62132613906762};
  /* Prix par défaut (remplacés automatiquement par les vrais prix Shopify de la fiche Extension de garantie) */
  var CONTENT={
    inclus:{title:'Essentielle',emoji:'🆓',badge:'INCLUS',color:'#4a9b6f',link:'/blogs/conseils-guides/garantie',covers:['12 mois de garantie','Pannes matérielles','Défauts de fonctionnement','Diagnostic à distance']},
    premium:{title:'Premium',emoji:'💎',badge:'+ 49,99 €',price:'49,99 €',variantId:VARIANTS.premium,color:'#E3A600',link:'/products/'+WARRANTY_HANDLE+'?variant='+VARIANTS.premium,covers:['Extension à 24 mois','Prise en charge prioritaire']},
    premiumPlus:{title:'Premium+',emoji:'🛡️',badge:'+ 79,99 €',price:'79,99 €',variantId:VARIANTS.premiumPlus,color:'#E3A600',link:'/products/'+WARRANTY_HANDLE+'?variant='+VARIANTS.premiumPlus,covers:['Tout Premium inclus','Casse accidentelle','Dommages liquides']}
  };
  function fmt(cents){return (cents/100).toFixed(2).replace('.',',').replace(',00','')+' €';}
  function refreshPrices(){
    fetch('/products/'+WARRANTY_HANDLE+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
      if(!p||!p.variants)return;
      ['premium','premiumPlus'].forEach(function(key){
        var v=p.variants.filter(function(x){return x.id===CONTENT[key].variantId;})[0];
        if(!v)return;
        var price=fmt(v.price);
        CONTENT[key].price=price;CONTENT[key].badge='+ '+price;
        var card=document.querySelector('.bmp-upsell-card--'+key);
        if(card){
          var b=card.querySelector('.bmp-upsell-badge');if(b)b.textContent='+ '+price;
          var btn=card.querySelector('.bmp-upsell-add');if(btn&&!btn.disabled)btn.textContent='Ajouter pour '+price;
        }
      });
    }).catch(function(){});
  }
  function currentHandle(){var m=location.pathname.match(/\/products\/([^/?#]+)/);return m?m[1]:'';}
  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
  function goCart(){if(typeof window.bmGoCart==='function'){window.bmGoCart();}else{location.href='/cart';}}
  function skipAndGoCart(){close();addCurrent().then(function(r){if(r && r.ok===false){return r.json().then(function(j){alert((j && (j.description||j.message))||'Erreur');});}goCart();});}
  function buildPopup(){
    if(document.getElementById('bmp-upsell'))return;
    var d=document.createElement('div');
    d.id='bmp-upsell';d.className='bmp-upsell';
    d.innerHTML='<div class="bmp-upsell-back"></div><div class="bmp-upsell-box" role="dialog" aria-modal="true"><button type="button" class="bmp-upsell-close" aria-label="Fermer et ajouter sans extension"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" style="pointer-events:none;vertical-align:middle"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><div class="bmp-upsell-head"><h2 class="bmp-upsell-title">Protégez votre PC portable plus longtemps</h2></div><div class="bmp-upsell-grid"></div><div class="bmp-upsell-foot"><button type="button" class="bmp-upsell-skip">Continuer sans extension</button></div></div>';
    document.body.appendChild(d);
    var grid=d.querySelector('.bmp-upsell-grid');
    ['inclus','premium','premiumPlus'].forEach(function(key){
      var c=CONTENT[key];
      var card=document.createElement('div');
      card.className='bmp-upsell-card bmp-upsell-card--'+key;
      var covers=c.covers.map(function(x){return '<li>'+esc(x)+'</li>';}).join('');
      var cta=c.variantId?('<button class="bmp-upsell-add" data-variant="'+c.variantId+'">Ajouter pour '+c.price+'</button>'):'<div class="bmp-upsell-inc">Déjà inclus</div>';
      var voirPlus=c.link?'<a class="bmp-upsell-more" href="'+c.link+'" target="_blank" rel="noopener">Voir plus</a>':'';
      card.innerHTML='<div class="bmp-upsell-badge" style="background:'+c.color+'">'+c.badge+'</div>'+voirPlus+'<h3><span class="bmp-upsell-emoji">'+c.emoji+'</span> '+c.title+'</h3><ul class="bmp-upsell-covers">'+covers+'</ul>'+cta;
      grid.appendChild(card);
    });
    /* 28/09/2026 (v.2.4) : la croix ajoute le produit SANS extension (meme action que "Continuer sans extension"). Le clic sur le fond et la touche Echap ferment sans rien ajouter. */
    d.querySelector('.bmp-upsell-back').addEventListener('click',cancel);
    d.querySelector('.bmp-upsell-close').addEventListener('click',skipAndGoCart);
    d.querySelector('.bmp-upsell-skip').addEventListener('click',skipAndGoCart);
    grid.querySelectorAll('.bmp-upsell-add').forEach(function(btn){
      btn.addEventListener('click',function(){
        var vid=parseInt(btn.dataset.variant,10);
        btn.disabled=true;btn.textContent='Ajout en cours...';
        addCurrent().then(function(){return addVariant(vid,1);}).then(function(){close();goCart();}).catch(function(e){console.error(e);btn.disabled=false;btn.textContent='Erreur, réessayer';});
      });
    });
    refreshPrices();
  }
  function open(){buildPopup();var d=document.getElementById('bmp-upsell');requestAnimationFrame(function(){d.classList.add('is-open');});document.body.style.overflow='hidden';}
  function close(){var d=document.getElementById('bmp-upsell');if(d)d.classList.remove('is-open');document.body.style.overflow='';}
  function cancel(){close();pendingForm=null;}
  /* 27/09/2026 : touche Echap = fermer sans ajouter */
  document.addEventListener('keydown',function(e){if(e.key!=='Escape'&&e.key!=='Esc')return;var d=document.getElementById('bmp-upsell');if(d&&d.classList.contains('is-open'))cancel();});
  var pendingForm=null;
  var directBusy=false; /* Point 1b 26/09/2026 : ajout direct sans popup (films, chargeurs, tablettes...) */
  function addCurrent(){
    if(!pendingForm)return Promise.resolve();
    var tc=window.bmpTypeCover;
    var payload=(tc && typeof tc.buildPayload==='function')?tc.buildPayload(pendingForm):null;
    if(payload){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)}).then(function(r){
        if(!r.ok)return r.json().then(function(j){var msg=(j && (j.description||j.message))||'Erreur';alert(msg);throw new Error(msg);});
        return r;
      });
    }
    var fd=new FormData(pendingForm);
    return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});
  }
  function addVariant(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})});
  }
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[action*="/cart/add"]');
    if(!form)return;
    var handle=currentHandle();
    if(!handle||SKIP_HANDLES.indexOf(handle)>=0)return;
    e.preventDefault();e.stopImmediatePropagation();
    pendingForm=form;
    if(window.bmpNoWarrantyUpsell===true){if(directBusy)return;directBusy=true;skipAndGoCart();setTimeout(function(){directBusy=false;},1500);return;}
    open();
  },true);
  var recapBtn=document.getElementById('bmp-recap-cta');
  if(recapBtn){
    recapBtn.addEventListener('click',function(e){
      var form=document.querySelector('.bmp-form');
      if(!form)return;
      var handle=currentHandle();
      if(SKIP_HANDLES.indexOf(handle)>=0)return;
      if(window.bmpNoWarrantyUpsell===true)return;
      e.preventDefault();e.stopImmediatePropagation();
      pendingForm=form;
      open();
    },true);
  }
})();